import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=c722f362&"
import script from "./AccountForm.vue?vue&type=script&lang=js&"
export * from "./AccountForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports